import { render, staticRenderFns } from "./IcoEllipsisVertical.vue?vue&type=template&id=a298a580"
import script from "./IcoEllipsisVertical.vue?vue&type=script&lang=js"
export * from "./IcoEllipsisVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports